import { render } from "./inactivity.html?vue&type=template&id=8e04f532&external"
import script from "./inactivity.js?vue&type=script&lang=js&external"
export * from "./inactivity.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__